// @flow
import { createContext } from 'react';

export type resortListContextType = {
  resortList: Array<{
    id: string,
    name: string,
    destination: {
      area: string,
      country: string,
    },
    comfort: string,
    seasonTrad: string,
  }>,
  setResortList: (*) => void,
};

export const ResortListContext = createContext<resortListContextType>({
  resortList: [],
  setResortList: () => {},
});
